import React from 'react';
import { PreviewCarousel } from './PreviewCarousel';
export function InsidePreview() {
  return <section className="w-full bg-navy-mid px-5 py-10 sm:py-16" data-id="element-118" data-mp="2r8wnisocbie5">
      <div className="mx-auto flex max-w-[600px] flex-col items-center text-center" data-id="element-119" data-mp="2rbit4mro7ntq">
        <span className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-120" data-mp="2mc5xpdmqh8fj">Take a look inside</span>
        <h2 className="mt-2 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-121" data-mp="2hdctkbtc6ts1">
          Inside <span className="text-gold" data-id="element-122" data-mp="3f0lcbz1ydoqc">THE COMPLETE ART YEAR™</span>
        </h2>
        <p className="mt-4 text-base font-bold text-white sm:text-lg" data-id="element-123" data-mp="3a0fm8nbc0aad">
          6 Core Volumes + 5 Professional Teacher Bonuses
        </p>
        <p className="mt-1 text-sm text-white" data-id="element-124" data-mp="30ae0i26gb3ym">
          Here&apos;s a closer look at some of the pages inside the material.
        </p>
        <div className="mt-5 w-full sm:mt-6" data-id="element-125" data-mp="1km5q8h02ytb">
          <PreviewCarousel data-id="element-126" data-mp="3syi9awkbjx5j" />
        </div>
      </div>
    </section>;
}